import { FC } from 'react'

import {
  BankingPaymentFilter,
  PaymentsCountWidgetDocument,
  PaymentsCountWidgetQuery,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  FinanceWidget,
  SupportedCharts,
} from 'modules/finance/components/Widgets/common/FinanceWidget'
import { removeNullBetween } from 'modules/finance/components/Widgets/common/utils'
import { buildWidget } from 'modules/finance/components/Widgets/common/widgets'

interface QueryArgsType {}

const prepareData = (data: PaymentsCountWidgetQuery) => {
  const count = data?.banking.paymentsConnection.aggregate?.count || 0

  return {
    countersChartDatas: [
      {
        label: i18n.t('finance.overview.outstanding_payments.total'),
        value: count,
        formattedValue: i18n.formatNumber(count),
      },
    ],
  }
}

export const buildPaymentsCountWidget = ({
  widgetTitle,
  queryArgs,
  filters,
}: {
  widgetTitle?: string
  queryArgs?: QueryArgsType
  filters: BankingPaymentFilter
}) => {
  const PaymentsCountWidget: FC<{
    data: ReturnType<typeof prepareData>
  }> = ({ data }) => {
    const { countersChartDatas } = data

    return (
      <FinanceWidget
        id={`paymentsCountDashboard-${widgetTitle}`}
        type={SupportedCharts.COUNTERS}
        showChart={false}
        countersChartDatas={countersChartDatas.map((chartData) => ({
          ...chartData,
          label: widgetTitle || chartData.label,
        }))}
      />
    )
  }

  // This is to avoid problems with date filter and between provoked by the use of datatable filters
  const filteredFilters = removeNullBetween(filters)

  return buildWidget({
    id: `paymentsCountWidget-${widgetTitle}`,
    component: PaymentsCountWidget,
    document: PaymentsCountWidgetDocument,
    prepareData: (data: PaymentsCountWidgetQuery) => prepareData(data),
    queryArgs: {
      ...queryArgs,
      paymentsFilters: {
        ...filteredFilters,
      },
    },
  })
}
